import { getBlockTypes, getUUId } from './maps';
/**
 * Block Header Parsing - Block's first 16 bytes
 * @param buffer Wdf as IOBuffer, i.e `new IOBuffer(file.wdf)`.
 * @param offset byte number where to start reading | uses current offset
 * @return blockHeader Block metadata
 */
export function readBlockHeader(buffer, offset) {
    /*an offset can be assigned manually if desired*/
    if (offset)
        buffer.offset = offset;
    const blockType = getBlockTypes(buffer.readUint32());
    const uuid = getUUId(buffer.readBytes(4));
    const blockSize = Number(buffer.readBigUint64()); // Bytes
    /* assign with appropriate type */
    return { blockType, uuid, blockSize };
}
//# sourceMappingURL=readBlockHeader.js.map